import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Spin, Tag, Col, Row,
} from 'antd';
import { Paper } from '@material-ui/core';
import { getUserProfileRequest } from '../redux/actions/user_profile_actions/get_user_profile.actions';

const mapStateToProps = (state) => {
    const { profile, loading } = state.UserManagement.User_profile.User_profile_table;
    return { profile, loading };
}; const
    Ava = `${process.env.PUBLIC_URL}/img/profile-male-circle2-512.png`;

export default connect(mapStateToProps, null)(class ProfilePreview extends Component {
    componentDidMount() {
        this.props.dispatch(getUserProfileRequest(this.props.id));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.id !== this.props.id) {
            this.props.dispatch(getUserProfileRequest(this.props.id));
        }
    }

    render() {
        const { profile, loading } = this.props;
        return (
            <Col span={23}>
                <Paper style={{ padding: 24 }}>
                    {!profile
                        ? (
                            <Spin tip="Preview Loading...">
                                <div style={{ minHeight: '10vh' }} />
                            </Spin>
                        )
                        : (
                            <Spin spinning={loading} tip="Profile is updating...">
                                <Row>
                                    <Col span={8}>
                                        <img src={(profile.person && profile.person.photos.big) || Ava} alt="avatar" className="profile__avatar" />
                                    </Col>
                                    <Col span={16}>
                                        <p className="profile__name">{`${(profile.person.ref_prefix_name ? `${profile.person.ref_prefix_name.name}. ` : '') + profile.person.first_name} ${profile.person.last_name}`}</p>
                                        <p className="profile__work">{profile.person.ref_department ? profile.person.ref_department.name : ''}</p>
                                        <p className="profile__work">
                                            Extension Number:
                                            {profile.person.extension_number}
                                        </p>
                                        <p className="profile__work">{profile.login.length > 30 ? `${profile.login.substring(0, 30)}...` : profile.login}</p>
                                        <div className="profile__contact">
                                            {profile.ref_user_status.name === 'Active'
                                                ? <Tag color="green" style={{ margin: '0' }}>{profile.ref_user_status.name}</Tag>
                                                : profile.ref_user_status.name === 'Suspended'
                                                    ? <Tag color="red" style={{ margin: '0' }}>{profile.ref_user_status.name}</Tag>
                                                    : <Tag color="orange" style={{ margin: '0' }}>{profile.ref_user_status.name}</Tag>}
                                        </div>
                                    </Col>
                                </Row>
                            </Spin>
                        )}
                </Paper>
            </Col>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfilePreview.js